import React from 'react';
import { Typography } from '@crisellevaldez/speculo-ui';
import { TipBox } from './TipBox';
import { SectionBox } from './SectionBox';

interface TeamContactProps {
  title?: string;
  description?: string;
  teamLeadName?: string;
  teamLeadRole?: string;
  teamLeadEmail?: string;
  teamLeadImage?: string;
  helperText?: string;
  children?: React.ReactNode;
}

export const TeamContact: React.FC<TeamContactProps> = ({
  title = '✅ Setup Complete!',
  description = 'Our team will keep you updated on progress and implementation.',
  teamLeadName = 'Christian',
  teamLeadRole = 'Team Lead',
  teamLeadEmail = 'team@speculo.ai',
  teamLeadImage = '/team-placeholder.jpg',
  helperText,
  children,
}) => {
  return (
    <SectionBox variant="green" type="parent">
      <div className="space-y-4">
        <div>
          <Typography variant="h3" className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">
            {title}
          </Typography>
          <p className="text-gray-700 dark:text-gray-300 text-sm">{description}</p>
        </div>

        <div className="bg-white dark:bg-white/5 rounded-lg p-6 border border-green-200 dark:border-green-800/40">
          <div className="flex items-start gap-4 mb-4">
            <img
              src={teamLeadImage}
              alt={teamLeadName}
              className="w-20 h-20 rounded-full bg-gray-300 dark:bg-gray-700 object-cover"
              onError={(e) => {
                (e.target as HTMLImageElement).src = '';
              }}
            />
            <div className="flex-1">
              <p className="text-lg font-bold text-gray-900 dark:text-gray-100 mb-1">{teamLeadName}</p>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{teamLeadRole}</p>
              <a href={`mailto:${teamLeadEmail}`} className="text-sm text-yellow-700 dark:text-yellow-400 underline">
                {teamLeadEmail}
              </a>
            </div>
          </div>

          {helperText && (
            <div className="mb-4">
              <TipBox>{helperText}</TipBox>
            </div>
          )}

          {children && <div>{children}</div>}
        </div>
      </div>
    </SectionBox>
  );
};
